import React, { Component } from "react"
import styled from "styled-components"
import ReactModal from "react-modal"
import { inject, observer } from "mobx-react"

import MODAL_STYLES from "~/components/modals/styles"
import FixedCloseButton from "~/components/modals/FixedCloseButton"
import QuestionModal from "~/components/traffic-tickets/FAQ/ModalContainer/QuestionModal"

import Spacer from "~/components/Spacer"
import DesktopContainer from "~/components/DesktopContainer"
import faqQuestions from "./faqQuestions"
import QuestionMarks from "~/components/traffic-tickets/FAQ/ModalContainer/FooterQuestions/BackgroundQuestionMarks"

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fff;
`

const FAQContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

const FAQTitle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 1.25em;
  color: ${props => props.theme.colors.text.menuItem};
  padding: 1em;
  text-align: center;
`

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  ${props => props.theme.media.mobile`
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `}
`

const Question = styled.button.attrs({ type: "button" })`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.primary};
  font-size: 1em;
  max-width: 11.25em;
  text-align: center;
  margin: 0.5em;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile
}))
@observer
class ParkingFlowFAQ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      selectedFaqItem: []
    }
  }

  openModal = () => this.setState({ showModal: true })

  hideModal = () => this.setState({ showModal: false })

  setItem = item => {
    this.setState({ selectedFaqItem: item })
    this.openModal()
  }

  render() {
    const { isMobile } = this.props
    const { selectedFaqItem } = this.state
    return (
      <>
        <ReactModal
          isOpen={this.state.showModal}
          style={
            isMobile
              ? MODAL_STYLES.mobile.general
              : MODAL_STYLES.desktop.topGray
          }
          closeTimeoutMS={300}
          contentLabel="Parking Frequently Asked Questions"
          onRequestClose={this.hideModal}
        >
          <FixedCloseButton
            color={this.props.isMobile ? "black" : "white"}
            onClick={this.hideModal}
          />
          <QuestionModal
            faqs={faqQuestions}
            selectedQuestion={selectedFaqItem[0]}
            selectedAnswer={selectedFaqItem[1]}
            onClick={this.setItem}
          />
        </ReactModal>
        <DesktopContainer>
          <Spacer mobile={90} desktop={90} />
          <MainContainer>
            <QuestionMarks>
              <FAQContainer>
                <FAQTitle>Frequently Asked Questions</FAQTitle>
                <Spacer mobile={16} desktop={16} />
                <QuestionContainer>
                  {faqQuestions.map(faqItem => (
                    <Question
                      key={faqItem[0]}
                      onClick={() => this.setItem(faqItem)}
                    >
                      {faqItem[0]}
                    </Question>
                  ))}
                </QuestionContainer>
                <Spacer mobile={32} desktop={32} />
              </FAQContainer>
            </QuestionMarks>
          </MainContainer>
          <Spacer mobile={32} desktop={32} />
        </DesktopContainer>
      </>
    )
  }
}

export default ParkingFlowFAQ
